import { useState } from "react";
import { ShieldCheck, CalendarCheck, Radio, Gem, Wrench, CreditCard, ArrowRight } from "lucide-react";
import { api, setToken } from "../lib/api";
import { Glass, Err } from "../ui";
import { Logo } from "../brand/Logo";

const PROMISES = [
  [ShieldCheck, "Life-time warranty", "Built to last — and guaranteed for as long as you live there."],
  [CalendarCheck, "On-time installation", "A dated schedule you can hold us to, visible in this app."],
  [Radio, "Live-feed updates", "Every task, milestone and site visit, the day it happens."],
  [Gem, "Premium quality", "Materials named and specified. Nothing swapped without you."],
  [Wrench, "Hassle-free install", "One team, one plan, one point of contact."],
  [CreditCard, "EMI or pay later", "Staged payments tied to milestones, not to dates."],
];

export function Login({ onLogin }) {
  const [mobile, setMobile] = useState("");
  const [passcode, setPasscode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function submit() {
    const digits = mobile.replace(/\D/g, "").slice(-10);
    if (digits.length < 10) return setErr("Enter the 10-digit mobile number registered with the studio.");
    if (!passcode.trim()) return setErr("Enter the passcode the studio shared with you.");
    setBusy(true);
    setErr("");
    try {
      const r = await api.post("/portal/login", { mobile: digits, passcode: passcode.trim() });
      setToken(r.token);
      onLogin(r.token, r.client_name);
    } catch (e) {
      setErr(e.message || "Could not sign you in.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app login">
      <div className="login-top">
        <Logo height={44} />
        <p className="login-eyebrow">Client portal</p>
        <h1>Welcome back.</h1>
        <p className="login-lede">Sign in to follow your project in real time.</p>
      </div>

      <Glass className="login-card" strong>
        <Err onDismiss={() => setErr("")}>{err}</Err>

        <div className="field">
          <label htmlFor="mob">Registered mobile number</label>
          <input
            id="mob"
            inputMode="numeric"
            autoComplete="tel"
            maxLength={14}
            placeholder="10-digit mobile"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="pass">Passcode</label>
          <input
            id="pass"
            type="password"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={12}
            placeholder="6-digit passcode"
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
          />
        </div>

        <button className="btn primary block" onClick={submit} disabled={busy}>
          {busy ? "Signing you in…" : "View my project"}
          {!busy && <ArrowRight size={16} />}
        </button>
      </Glass>

      <p className="login-note">
        Use the mobile number registered with your studio and the passcode they shared. Lost it? Message us on
        WhatsApp and we will resend it.
      </p>

      <div className="promises">
        {PROMISES.map(([Icon, head, note]) => (
          <Glass className="promise" key={head}>
            <span className="tile-art" style={{ width: 40, height: 40, borderRadius: 14 }}>
              <Icon size={20} strokeWidth={1.5} />
            </span>
            <b>{head}</b>
            <small>{note}</small>
          </Glass>
        ))}
      </div>
    </div>
  );
}
